module.exports = __webpack_public_path__ + "img/IMG_3438.f426a8ba.jpg";